<template>
  <div
    class="observer-item d-flex flew-row align-center"
    :class="{
      'is-create': isCreateRoute,
      'is-dashboard': isDashBoardRoute
    }"
    @mouseenter="isMouseHover = true"
    @mouseleave="isMouseHover = false"
  >
    <div class="d-flex observer-container align-center">
      <div
        class="observer-email text-truncate"
        :data-test-id="`added-observer-${observer.email}`"
      >
        {{ observer.email }}
      </div>

      <span
        v-if="observer.isAdmin"
        class="observer-admin"
        :data-test-id="`observer-admin-${observer.email}`"
      >
        {{ i18n.t('labels.admin') }}
      </span>
    </div>

    <v-spacer />
    <div class="d-flex justify-end align-center flex-shrink-0">
      <ParticipantMenu
        v-if="!isCreateRoute && !isDashBoardRoute"
        :participant-email="observer.email"
        :participant-id="observer.observerId"
        :participant-policy="observer.observerPolicy"
        participant-type="observer"
        :show-activator="isMouseHover"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ParticipantMenu from '@/components/menus/ParticipantMenu.vue';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

defineProps({
  observer: {
    type: Object,
    required: true
  },
  isDashBoard: {
    type: Boolean,
    default: false
  }
});

const i18n = useI18n();
const isMouseHover = ref(false);
const route = useRoute();
const isCreateRoute = computed(
  () => route.name === 'document-create' || route.name === 'p-document-create'
);
const isDashBoardRoute = computed(() => route.name === 'dashboard');
</script>

<style scoped lang="scss">
.observer-item {
  &.is-dashboard {
    min-height: 32px;
  }
}

.observer-email {
  word-break: break-word;
  font-style: normal;
  font-weight: 400;
}

.observer-admin {
  margin-left: 12px;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.015em;
  color: rgb(var(--v-theme-grey));

  &::before {
    content: '|';
    margin-right: 12px;
    color: rgb(var(--v-theme-grey-lighten-1));
  }
}

.observer-container {
  max-width: calc(100% - 24px);
}
</style>
